import { Input } from "antd";
import { useState } from "react";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";
import ReactQuill from "react-quill";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const InputField = ({
  onChangeInput,
  name,
  title,
  placeholder,
  isQuill,
  value,
  handleChangeTextEditor,
  required,
  QuilHeight,
  disabled,
}) => {
  const { translator } = useLanguageTranslator();
  return (
    <div className={styles.inputAndLabel}>
      <div className={styles.label}>{title}</div>
      <ConditionalRenderer condition={!isQuill}>
        <Input
          name={name}
          onChange={onChangeInput}
          value={value}
          placeholder={placeholder}
          style={{ height: "5dvh" }}
          className={styles.input}
          required={required}
          disabled={disabled}
          maxLength={40}
        />
      </ConditionalRenderer>
      <ConditionalRenderer condition={isQuill}>
        <div className={styles.textEditor}>
          <ReactQuill
            theme="snow"
            value={value}
            onChange={handleChangeTextEditor}
            placeholder={translator("writeSomething")}
            style={{ width: "100%", height: QuilHeight }}
          />
        </div>
      </ConditionalRenderer>
    </div>
  );
};
